import { create } from "zustand"
import type { UserEvent } from "@/services/api/cronos/user/events/get-all"

interface EventModalState {
  isOpen: boolean
  type: "edition" | "deletion"
  event: UserEvent | null
}

interface EventModalActions {
  openEventModal: ({ type, event }: { type: "edition" | "deletion"; event: UserEvent }) => void
  closeEventModal: () => void
}

const initialState: EventModalState = {
  isOpen: false,
  type: "deletion",
  event: null,
}

const useEventModal = create<EventModalState & EventModalActions>()((set) => ({
  ...initialState,
  openEventModal: ({ type, event }) => set({ isOpen: true, type, event }),
  closeEventModal: () => set(initialState),
}))

export default useEventModal
